export default __webpack_public_path__ + "static/media/icon_02_display.ff0cec44.svg";